import React from 'react';
import PropTypes from 'prop-types';
import { FaSearch } from 'react-icons/fa';
import { CollapsibleFilter } from '~/components/CollapsibleFilter';
import './styles.scss';

function SearchComponent({
  countFilter,
  codeValue,
  nameValue,
  handleCodeChange,
  handleNameChange,
  handleSubmit
}) {
  return (
    <CollapsibleFilter countFilters={countFilter}>
      <form className="formContainer" onSubmit={handleSubmit}>
        <label id="searchText">Pesquisar</label>
        <div className="rowContainer">
          <div id="code-erp" className="inputHolder">
            <span>Código ERP</span>
            <input
              type="text"
              name="code"
              value={codeValue}
              onChange={handleCodeChange}
            />
          </div>
          <div className="inputHolder defaultFlex">
            <span>Software</span>
            <input
              type="text"
              name="name"
              value={nameValue}
              onChange={handleNameChange}
            />
          </div>
          <button className="buttonBaseOnly" id="baseButtonIcon" onClick={handleSubmit}>
            <FaSearch id="baseNameIcon" />
            <span>BUSCAR</span>
          </button>
        </div>
      </form>
    </CollapsibleFilter>
  );
}

SearchComponent.propTypes = {
  countFilter: PropTypes.number,
  codeValue: PropTypes.string.isRequired,
  nameValue: PropTypes.string.isRequired,
  handleCodeChange: PropTypes.func.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default SearchComponent;
